import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrHelpCategory.ts
var t = () => e("helpCategory");
//#endregion
export { t as useTrHelpCategory };
